import PropTypes from 'prop-types'
import React, { useEffect } from "react"
import { connect, useDispatch } from "react-redux"
import withRouter from '../../components/Common/withRouter'

import { logoutUser } from "../../store/actions"
import { useNavigate } from 'react-router-dom';
import { appConstants } from '../../constants/app_constants'

const Logout = () => {

  document.title = " Logout | " + appConstants.cName

  const history = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(logoutUser({ history: history }));
  }, [dispatch, history]);

  return <></>
}

Logout.propTypes = {
  history: PropTypes.object,
  logoutUser: PropTypes.func
}

export default withRouter(connect(null, { logoutUser })(Logout));
